/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { faCouch } from '@fortawesome/free-solid-svg-icons/faCouch'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useIntl } from 'react-intl'
import { parseNumber } from '@jalik/form-parser'
import FormNumberField, {
  FormNumberFieldProps
} from '../../../../client/js/components/form/fields/FormNumberField'

function LivingRoomsField (props: FormNumberFieldProps) {
  const { name = 'livingRooms', ...others } = props
  const intl = useIntl()
  return (
    <FormNumberField
      label={intl.formatMessage({
        id: 'livingRooms',
        defaultMessage: 'Salons'
      })}
      name={name}
      parser={parseNumber}
      leftSection={(
        <FontAwesomeIcon
          fixedWidth
          icon={faCouch}
        />
      )}
      {...others}
    />
  )
}

export default LivingRoomsField
